<div class="container-main">
    <div class="header-container">
        <div class="header-grid">
            <span class="title-txt">{{ 'login.title' | translate }}</span>
            <span class="subtitle-txt">{{ 'login.subheader' | translate }}</span>
        </div>
    </div>
    <form [formGroup]="loginForm" id="loginform" >
        <div class="form-align">
            <div class="container-validation">
                <span>
                    {{ 'inputs.email' | translate }}
                </span>
                <input
                    autocomplete="off"
                    formControlName="email"
                    [ngClass]="{
                    'input-form' : !isValidField('email'),
                    'input-error' : isValidField('email') || respError }"
                    type="email"
                    maxlength="50"
                    placeholder="{{ 'inputs.email' | translate }}">
            </div>
            <div class="container-validation">
                <span>
                    {{ 'inputs.password' | translate }}
                </span>
                <input
                    autocomplete="off"
                    formControlName="password"
                    [ngClass]="{
                    'input-form' : !isValidField('password'),
                    'input-error' : isValidField('password') || respError }"
                    type="password"
                    maxlength="50"
                    placeholder=" {{ 'inputs.password' | translate }} ">
            </div>
        </div>
        <div class="link-button">
            <a  routerLink="/auth/forgot-password"> {{'login.link1'| translate}} </a>
			<app-button *ngIf="btnDisabled===true"  btnType="primaryMedium" [activo]="true" btnNombre="buttons.login">
			</app-button>
			<app-button *ngIf="btnDisabled===false"  btnType="primaryMedium" [activo]="false" btnNombre="buttons.login" (click)="login()">
			</app-button>
        </div>
    </form>
</div>


